//  src/components/legal/legalPageShell.jsx
import React from 'react';
import { Breadcrumbs, PublicSeo } from '../public/PublicUi';
import { BRAND } from '../public/publicSiteData';
import './legalPages.css';

export function LegalPageShell({
  page,
  effectiveDate,
  summary,
  tableOfContents,
  children,
  closingNote,
}) {
  const breadcrumbs = [{ label: 'Home', to: '/' }, { label: page.heading }];

  return (
    <div className="ts-public-page ts-page--legal">
      <PublicSeo
        page={page}
        breadcrumbs={breadcrumbs}
        robots="noindex,nofollow"
        includeCanonical={false}
        includeStructuredData={false}
      />
      <Breadcrumbs items={breadcrumbs} />

      <main className="ts-legal-page">
        <div className="ts-legal-container">
          <header className="ts-legal-header">
            <p className="ts-legal-eyebrow">{page.eyebrow || 'LEGAL'}</p>
            <h1>{page.heading}</h1>
            <p className="ts-legal-effective">Effective date: {effectiveDate}</p>
            <div className="ts-legal-summary">{summary}</div>
          </header>

          {Array.isArray(tableOfContents) && tableOfContents.length ? (
            <nav className="ts-legal-toc" aria-label={`${page.heading} table of contents`}>
              <h2>On this page</h2>
              <ol>
                {tableOfContents.map((item) => (
                  <li key={item.id}>
                    <a href={`#${item.id}`}>{item.label}</a>
                  </li>
                ))}
              </ol>
            </nav>
          ) : null}

          <div className="ts-legal-content">{children}</div>

          {closingNote ? <div className="ts-legal-closing-note">{closingNote}</div> : null}
        </div>
      </main>
    </div>
  );
}

export function LegalSection({ id, title, children }) {
  return (
    <section id={id} className="ts-legal-section" aria-labelledby={`${id}-title`}>
      <h2 id={`${id}-title`}>{title}</h2>
      <div className="ts-legal-section__body">{children}</div>
    </section>
  );
}

export function LegalList({ children }) {
  return <ul className="ts-legal-list">{children}</ul>;
}

export function LegalCallout({ children, tone = 'info' }) {
  return <aside className={`ts-legal-callout ts-legal-callout--${tone}`}>{children}</aside>;
}

export function LegalContactBlock() {
  return (
    <address className="ts-legal-contact">
      <strong>{BRAND.name} is operated by {BRAND.legalName}.</strong>
      <span>{BRAND.address}</span>
      <span>
        Phone: <a href={BRAND.phoneHref}>{BRAND.phoneDisplay}</a>
      </span>
      <span>
        Email: <a href={`mailto:${BRAND.email}`}>{BRAND.email}</a>
      </span>
      {BRAND.emailContext ? <small>{BRAND.emailContext}</small> : null}
    </address>
  );
}


